import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CheckoutResponse, PriceDTO } from '../models/price';
import { Location } from '../models/location';
import { SubscriptionType } from '@app/shared/models/subscription-type';
import { SubscriptionDetails } from '@app/shared/models/subscription-details';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService extends ApiService {
  constructor() {
    super();
    this.url = 'subscriptions/';
  }

  getPrices(): Observable<PriceDTO[]> {
    return this.get({ url: 'prices' });
  }

  getAnnualPricePercentDiscount(): Observable<number> {
    return this.get<number>({ url: 'annual-price-percent-discount' });
  }

  getMaxNumberOfSeats(): Observable<number> {
    return this.get<number>({ url: 'max-number-of-seats' });
  }

  createCheckoutSession(
    priceId: string,
    seats: number,
    customerId: string | null = null,
  ): Observable<CheckoutResponse> {
    return this.post({ url: 'checkout-session', body: { priceId, seats, customerId } });
  }

  createBillingPortalSession(updateSubscription = false): Observable<CheckoutResponse> {
    return this.post({ url: 'billing-portal-session', params: { updateSubscription } });
  }

  createUnpaidInvoicePaymentLink(): Observable<CheckoutResponse> {
    return this.post({ url: 'unpaid-invoice-payment-link' });
  }

  getSubscriptionSettings(): Observable<Location[]> {
    return this.get<Location[]>({ url: 'settings' });
  }

  getTrialDurationInDays(): Observable<number> {
    return this.get<number>({ url: 'trial/duration-in-days' });
  }

  getSubscriptionInfo(): Observable<SubscriptionType> {
    return this.get<SubscriptionType>({ url: 'info' }).pipe(
      map((subscription) => ({
        ...subscription,
        isBlocked: subscription.isBlocked ?? subscription.blocked ?? false,
      })),
    );
  }

  getSubscriptionDetails(): Observable<SubscriptionDetails> {
    return this.get<SubscriptionDetails>({ url: 'details' });
  }
}
